import React, { useContext } from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';
import { Button } from 'components';
import { LocalContext } from 'context';
import { flexContainer, gridContainer, fullGridContainer, breakpoints } from 'styles';
import FB from 'assets/svgs/fb-icon.svg';
import INSTA from 'assets/svgs/insta-icon.svg';
import IN from 'assets/svgs/linkedin-icon.svg';
import TW from 'assets/svgs/twitter-icon.svg';
import FBLogo from 'assets/svgs/fighting-blindness-logo.svg';
import AXLogo from 'assets/svgs/agency-x-logo.svg';

const Footer = () => {
  const { theme, contactRef } = useContext(LocalContext);
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { order: [ASC], fields: [frontmatter___id] }
        filter: { fileAbsolutePath: { regex: "/(sponsors)/" } }
      ) {
        nodes {
          id
          frontmatter {
            id
            link
            image {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  formats: [AUTO, WEBP, AVIF]
                  width: 800
                  placeholder: TRACED_SVG
                )
              }
            }
          }
        }
      }
    }
  `);



  const { nodes: sponsors } = data.allMarkdownRemark;

  return (
    <>
      <FlexContainer>
        <H3 theme={theme}>Our Sponsors</H3>
        <MainSponsors>
          {sponsors.map((sponsor, i) => (
            <a href={sponsor.frontmatter.link} target="blank" key={i}>
              <MainSponsorImg
                image={getImage(sponsor.frontmatter.image.childImageSharp)}
                objectFit="contain"
                alt="partner-logo"
              />
            </a>
          ))}
        </MainSponsors>

        {/* <Sponsors>
          {sponsors.slice(2, 13).map((sponsor, i) => (
            <a href={sponsor.frontmatter.link} target="blank" key={i}>
              <SponsorImg
                image={getImage(sponsor.frontmatter.image.childImageSharp)}
                objectFit="contain"
                alt="partner-logo"
              />
            </a>
          ))}
        </Sponsors> */}
      </FlexContainer>
      {/* <Donations theme={theme}>
        <div>
          <H3 style={{ marginBottom: '0px', width: '100%' }}>Make A Donation</H3>
          <p>We are the charity in Ireland funding research into treatments for sight loss</p>
        </div>
        <a href="https://fightingblindness.ie/donate" target="blank">
          <Button width="12rem">Donate</Button>
        </a>
      </Donations> */}
      <GridContainer theme={theme}>
        <Subscribe theme={theme}>
          <a href="https://www.fightingblindness.ie/" target="blank">
            <FBLogo />
          </a>
          <P style={{ marginBottom: '3rem' }}>
            Retina 2021 is brought to you by Agency X in conjunction with Fighting Blindness
          </P>
          <a href="https://www.agencyx.ie" target="blank">
            <AXLogo className="ex-logo" />
          </a>
        </Subscribe>
        <Contact id="contact" ref={contactRef} theme={theme}>
          <H3>Tech Support</H3>
          <P>
            Email: <a href="mailto:support@agencyx.ie">support@agencyx.ie</a>
          </P>
          <H3>Contact us</H3>
          <P>
            Fighting Blindness,
            <br />
            3rd Floor, 7 Ely Place,
            <br />
            Dublin 2, D02 TW98
            <br />
            <br />
            Telephone: <a href="tel:00 353 1 6789 004">+ 353 1 6789 004</a>
            <br />
            Email: <a href="mailto:research@fightingblindness.ie">research@fightingblindness.ie</a>
          </P>
        </Contact>
        <Socials>
          <H3>Follow us on Social</H3>
          <SocialLink
            theme={theme}
            href="https://www.facebook.com/Fighting.Blindness.Ireland/"
            target="blank">
            <FB />
            Fighting.Blindness.Ireland
          </SocialLink>
          <SocialLink theme={theme} href="https://twitter.com/fight_blindness" target="blank">
            <TW />
            @fight_blindness
          </SocialLink>
          <SocialLink
            theme={theme}
            href="https://www.linkedin.com/company/fighting-blindness/"
            target="blank">
            <IN />
            fighting-blindness
          </SocialLink>
          <SocialLink
            theme={theme}
            href="https://www.instagram.com/fightingblindness/"
            target="blank">
            <INSTA />
            fightingblindness
          </SocialLink>
        </Socials>
      </GridContainer>
      <FooterInfo>
        <FooterCopyright theme={theme}>
          Copyright © 2021 - Fighting Blindness | Reg Charity No 20013349 | Company No 109625 -
          Designed and Developed by Agency X{' '}
        </FooterCopyright>
        <FooterTerms theme={theme}>
          <a href="https://www.fightingblindness.ie/privacy-policy/">Privacy Policy</a>
        </FooterTerms>
      </FooterInfo>
    </>
  );
};

const FlexContainer = styled.section`
  ${flexContainer}
  margin-top:6rem;
  margin-bottom: 6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const GridContainer = styled.footer`
  position: relative;
  ${fullGridContainer}
  padding: 3rem 1.25rem;
  grid-row-gap: 3.75rem;
  color: ${({ theme }) => theme.contrastTextColor};
  background: ${({ theme }) => theme.bg};

  @media (min-width: 768px) {
    padding: 40px;
  }
  @media (min-width: 1150px) {
    padding: 0;
    padding-top: 4rem;
    padding-bottom: 5rem;
  }
`;

const H3 = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  margin-top: 0px;
  margin-bottom: 2.5rem;
  color: ${({ theme }) => theme.textColor};
`;

const P = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.25rem;
  margin-top: 0px;
`;

const Donations = styled(FlexContainer)`
  background-color: ${({ theme }) => theme.bgLight};
  h3,
  p {
    color: ${({ theme }) => theme.textColor};
  }
  color: #000;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 0.625rem;
  margin: 1.25rem;
  padding: 1.25rem 2.25rem;
  align-items: center;
  text-align: center;
  div {
    grid-column: 1/7;
  }
  p {
    grid-column: 1/7;
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
  }
  a {
    grid-column: 1/8;
    justify-self: center;
  }
  @media (min-width: ${breakpoints.sm}) {
    grid-column: 1/7;
    grid-gap: 1.25rem;
    text-align: left;
    margin: 2.5rem 1.25rem;
    div {
      grid-column: 1/5;
    }
    p {
      margin-bottom: 0px;
    }
    a {
      grid-column: 5/7;
      justify-self: end;
    }
  }
  @media (min-width: ${breakpoints.lg}) {
    grid-column: 2/12;
    grid-template-columns: repeat(10, 1fr);
    grid-gap: 1.25rem;
    text-align: left;
    margin: 2.5rem 1.25rem;
    div {
      grid-column: 1/9;
    }
    p {
      grid-column: 1/9;
      margin-bottom: 0px;
    }
    a {
      grid-column: 9/11;
    }
  }
`;

const Subscribe = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1/7;
  svg {
    width: 250px;
    height: auto;
    max-width: 100%;
    margin-bottom: 1.5rem;
    path {
      fill: ${({ theme }) => (theme.className === 'contrast' ? 'yellow' : 'auto')};
    }
    &.ex-logo {
      width: 175px;
    }
  }
  @media (min-width: 1150px) {
    grid-column: 2/5;
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1/7;
  ${P} {
    margin-bottom:1.25rem;
  }
  ${H3}{
    margin-bottom:1.25rem;
  }
  a {
    color: white;
    transition: 0.25s;

    :visited {
      color: white;
    }
    :hover {
      color: ${({ theme }) => theme.fg};
    }
  }
  @media (min-width: 1150px) {
    grid-column: 6/9;
  }
`;

const Socials = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1/7;
  @media (min-width: 1150px) {
    grid-column: 9/12;
  }
`;

const SocialLink = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1.25rem;
  cursor: pointer;
  transition: 0.5s;
  color: white;
  svg {
    margin-right: 1.5rem;
    width: 2.5rem;
    height: 2.5rem;
    circle {
      transition: 0.5s;
      fill: ${({ theme }) => (theme.className === 'contrast' ? 'yellow' : theme.fg)};
    }
    path {
      transition: 0.5s;

      fill: ${({ theme }) => (theme.className === 'contrast' ? 'black' : 'white')};
    }
  }
  :visited {
    color: white;
  }
  &:hover {
    color: ${({ theme }) => theme.fg};
    svg {
      circle {
        fill: ${({ theme }) => (theme.className === 'contrast' ? 'black' : 'white')};
      }
      path {
        fill: ${({ theme }) => (theme.className === 'contrast' ? 'white' : theme.fg)};
      }
    }
  }
`;

const FooterInfo = styled.footer`
  ${gridContainer}
  padding: 1rem 1.25rem;
  align-items: start;
  @media (min-width: 768px) {
    grid-column: 1/7;
  }
  @media (min-width: 1150px) {
    padding: 9px 0px;
    grid-column: 2/13;
  }
`;

const FooterCopyright = styled.p`
  grid-column: 1/7;

  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.25rem;
  margin-top: 0px;
  color: ${({ theme }) => theme.textColor};
  @media (min-width: 768px) {
    grid-column: 1/7;
  }
  @media (min-width: 1150px) {
    grid-column: 1/8;
  }
`;

const FooterTerms = styled.div`
  display: flex;
  justify-content: flex-start;
  grid-column: 1/7;
  a {
    font-style: normal;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.25rem;
    margin-right: 1.25rem;
    color: ${({ theme }) => theme.textColor};
  }
  @media (min-width: 1150px) {
    grid-column: 8/11;
  }
`;

const MainSponsors = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-column-gap: 3rem;
  grid-row-gap: 3rem;
  grid-template-columns: repeat(auto-fit, minmax(2.5rem, 300px));
  height: auto;
  justify-content: center;
  margin: 1.5rem auto 4rem;
  padding: 0px 1.25rem;
  width: 100%;

  a {
    display: grid;
  }
`;

const Sponsors = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  height: auto;
  padding: 0px 1rem;
  a {
    width: 75px;
    margin: 1rem;
  }
  @media (min-width: 768px) {
    a {
      width: 125px;
      margin: 1rem 3rem;
    }
  }
`;

const SponsorImg = styled(GatsbyImage)`
  width: 100%;
  height: auto;
  object-fit: contain !important;
  picture {
    img {
      object-fit: contain !important;
    }
  }
`;

const MainSponsorImg = styled(SponsorImg)`
  max-height: 8rem;
`;

export default Footer;
